import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Simran
 * id A4250284-2784-405C-A62F-E6C546D66777
 * name clock-alert
 * version: 2.4.85
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/clock-alert.svg
 * tags
 * - Date / Time 
 * - Alert / Error 
 */
export const ClockAlertIcon = createSvgIcon(<><path d="M20 12H22V18H20V12M20 20H22V22H20V20M12 2C6.5 2 2 6.5 2 12S6.5 22 12 22C14.3 22 16.3 21.2 18 20V10H21.8C20.9 5.4 16.8 2 12 2M16.2 16.2L11 13V7H12.5V12.2L17 14.9L16.2 16.2Z" /></>, 'ClockAlertIcon');
export default ClockAlertIcon